package com.downdogapp

enum class FontWeight(val fileName: String, val value: Int) {

  LIGHT("Montserrat-Light", 300),
  REGULAR("Montserrat-Regular", 400),
  MEDIUM("Montserrat-Medium", 500),
  SEMIBOLD("Montserrat-SemiBold", 600),
  BOLD("Montserrat-Bold", 700);

  override fun toString() = "$value" // needed for js
}
